import { useEffect, useRef } from "react";

interface UseScrollToCurrentVersionProps {
  activeVersionNumber: number | null;
  versions: { number: number }[];
  containerRef: React.RefObject<HTMLDivElement>;
}

const useScrollToCurrentVersion = ({
  activeVersionNumber,
  versions,
  containerRef,
}: UseScrollToCurrentVersionProps) => {
  const hasScrolledToVersion = useRef(false);

  useEffect(() => {
    hasScrolledToVersion.current = false;
  }, [activeVersionNumber]);

  useEffect(() => {
    if (
      !versions.length ||
      activeVersionNumber === null ||
      hasScrolledToVersion.current ||
      !containerRef.current
    ) {
      return;
    }

    const activeVersionElement = containerRef.current.querySelector(
      `[data-version-number="${activeVersionNumber}"]`,
    );

    if (!activeVersionElement) {
      return;
    }

    const containerRect = containerRef.current.getBoundingClientRect();
    const elementRect = activeVersionElement.getBoundingClientRect();

    const isVisible =
      elementRect.top >= containerRect.top &&
      elementRect.bottom <= containerRect.bottom;

    if (!isVisible) {
      activeVersionElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }

    hasScrolledToVersion.current = true;
  }, [versions, activeVersionNumber, containerRef]);
};

export default useScrollToCurrentVersion;
